import app from 'flarum/common/app';

app.initializers.add('xypp/pay-to-read', () => {
});
